import React, { useState, useEffect } from "react";
// import "../navbar.scss";
import Logo from "../img/base/111.png";
import axios from "axios";
import {
  // Container,
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavbarText,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Card,
  CardBody,
  Label,
  Input,
  Spinner,
  Alert,
} from "reactstrap";
import * as FaIcons from "react-icons/fa";
import { Outlet, useNavigate, Link } from "react-router-dom";
import SidebarAdm from "./SidebarAdm";
import Swal from "sweetalert2";
import { useAuth } from "../../utils/AuthContext";
import useIdleTimer from "../../utils/useIdleTimer";

const TIMEOUT_DURATION = 10 * 60 * 1000; // 10 minutos en milisegundos

function NavbarAdm(args) {
  const [modalContra, setModalContra] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  ////LOGOUT
  ////sesion cierre
  const { isAuthenticated, logoutSubmit } = useAuth();
  const [remainingTime, setRemainingTime] = useState(TIMEOUT_DURATION);
  const abrirCerrarModalContra = () => {
    setModalContra(!modalContra);
  };

  const baseUrl = "https://bqef-bo.com/api/A/apiAdm.php";
  const [dataAdm, setDataAdm] = useState({
    id_adm: "",
    contrasena: "",
    contrasena_lit: "",
    // otras propiedades si las tienes
  });

  ////Datos usuario Administrador
  const peticionGetAdm = async () => {
    setLoading(true);
    setError("");
    const adminId = sessionStorage.getItem("iduser");
    try {
      const res = await axios.get(`${baseUrl}?action=getInfoAdm&id=${adminId}`);
      const infoAdmArray =
        res.data.InfoAdm && Array.isArray(res.data.InfoAdm)
          ? res.data.InfoAdm
          : [];
      // console.log(res.data);
      if (infoAdmArray.length > 0) {
        setDataAdm(infoAdmArray[0]);
      } else {
        setDataAdm({});
      }
    } catch (error) {
      console.log(error);
      setError("Error al cargar los datos");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    peticionGetAdm();
  }, []);

  // Configurar el temporizador de inactividad
  useIdleTimer(TIMEOUT_DURATION, logoutSubmit, setRemainingTime);

  // Iniciar el temporizador solo si el usuario está autenticado
  useEffect(() => {
    if (isAuthenticated) {
      setRemainingTime(TIMEOUT_DURATION); // Reiniciar el tiempo restante
    } else {
      setRemainingTime(TIMEOUT_DURATION); // Reiniciar el tiempo si el usuario no está autenticado
    }
  }, [isAuthenticated]);

  // Función para formatear el tiempo restante en minutos y segundos
  const formatTime = (time) => {
    const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((time % (1000 * 60)) / 1000);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };
  //
  const navigate = useNavigate();
  // Función para cerrar sesión
  const logoutSub = () => {
    Swal.fire({
      title: "¿Está seguro?",
      text: "¿Desea cerrar sesión?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, cerrar sesión!",
    }).then((result) => {
      if (result.isConfirmed) {
        sessionStorage.clear(); // Limpia la sesión
        logoutSubmit(); // Actualiza el estado de autenticación
        navigate("/"); // Redirige a la página principal
      }
    });
  };
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  /////Modificar Constraseña Administrador
  const peticionPutContra = async () => {
    const dataToSend = {
      id_adm: dataAdm.id_adm,
      contrasena: dataAdm.contrasena,
      usu_modificacion: dataAdm.id_adm,
    };

    // console.log("id_adm:", dataAdm.id_adm);
    // console.log("Datos a enviar:", dataToSend);

    try {
      // const response =
      await axios.put(`${baseUrl}?action=updateContraAdm`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      // console.log("Respuesta del servidor:", response.data);

      // Actualizar el estado dataAdm con la nueva contraseña
      setDataAdm((prevDataAdm) => ({
        ...prevDataAdm,
        contrasena: dataAdm.contrasena,
      }));
      peticionGetAdm();
      abrirCerrarModalContra();
      mostrarAlertaU();
    } catch (error) {
      console.error("Error en peticionPut:", error);
    }
  };
  useEffect(() => {
    peticionGetAdm();
    getConvocatoria();
  }, []);
  ///
  const [lista, setLista] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  ////Mostrar comunicados
  const getConvocatoria = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${baseUrl}?action=getConv`);
      const receivedData =
        res.data.Convocatorias && Array.isArray(res.data.Convocatorias)
          ? res.data.Convocatorias
          : [];

      // Filtrar solo los archivos de tipo 'convocatoria'
      const convocatorias = receivedData.filter(
        (item) => item.tipo_archivo === "convocatoria",
      );

      // Obtener el último archivo de convocatoria
      const ultimoConvocatoria =
        convocatorias.length > 0
          ? convocatorias[convocatorias.length - 1]
          : null;

      // console.log(ultimoConvocatoria);

      // Si quieres guardar solo el último en el estado
      setLista(ultimoConvocatoria ? [ultimoConvocatoria] : []);
    } catch (error) {
      setError("Error al cargar los datos");
    } finally {
      setLoading(false);
    }
  };

  ////Descargar PDF
  const handleDescargarPdf = async () => {
    var link = document.createElement("a");
    link.setAttribute(
      "href",
      "data:application/pdf;base64," + selectedItem.archivo_com,
    );
    link.setAttribute("download", selectedItem.nom_doc);
    link.click();
  };

  ////ALERTAS
  const mostrarAlertaU = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Éxito!",
      text: "Contraseña Actualizada.",
      timer: 5000,
      icon: "success",
    });
  };
  const mostrarAlertaBack = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Éxito!",
      text: "Backup generado correctamente.",
      timer: 5000,
      icon: "success",
    });
  };
  const mostrarAlertaBackE = () => {
    Swal.fire({
      confirmButtonColor: "#dc3545",
      title: "Oops...",
      text: "Error en la operación",
      timer: 5000,
      icon: "error",
    });
  };
  ////Generar Backup
  const handleBackup = () => {
    setLoading(true);
    axios
      .get("https://bqef-bo.com/api/A/backup.php")
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/sql" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        const fechaHora = new Date()
          .toISOString()
          .replace(/:/g, "-")
          .replace(/\..+/, "");
        link.download = `backup-${fechaHora}.sql`;
        link.click();
        setLoading(false);
        mostrarAlertaBack();
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
        mostrarAlertaBackE();
      });
  };
  ////
  const handleSelectItem = (item) => {
    setSelectedItem(item);
  };
  ////Boton Cerrar
  const closeBtn = () => {
    setSelectedItem(null);
  };
  const cloBtn = (
    <Button
      className="close"
      onClick={closeBtn}
      style={{
        color: "white",
        position: "absolute",
        right: "10px",
        // top: "5%",
        // transform: "translateY(-50%)",
        // background: "none",
        // border: "none",
        // fontSize: "2rem",
      }}
      aria-label="Close"
    >
      &times;
    </Button>
  );
  ////Modal VER MANUAL PERSONAL
  const [modalVerManual, setModalVerManual] = useState(false);
  const toggleModal = () => setModalVerManual(!modalVerManual);
  const cloBtnM = (
    <Button
      className="close"
      onClick={toggleModal}
      style={{
        color: "white",
        position: "absolute",
        right: "10px",
        // top: "5%",
        // transform: "translateY(-50%)",
        // background: "none",
        // border: "none",
        // fontSize: "2rem",
      }}
      aria-label="Close"
    >
      &times;
    </Button>
  );
  ///pdf ver manual
  const handleDownloadPdf = () => {
    const link = document.createElement("a");
    link.href = require("../../Pages/Admin/documentos/manuales/MANUAL USUARIO ADMIN.pdf");
    link.download = "MANUAL USUARIO ADMIN.pdf";
    link.click();
  };
  // Definir un objeto de validación para contraseña
  const validation = {
    contrasena: {
      regex:
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%?&%"*#¡¿])[A-Za-z\d@$!%?&%"*#¡¿]{8,}$/,
      isValid: true,
    },
  };

  const [isValid, setIsValid] = useState({
    contrasena: false,
  });
  ///
  const handleChange = (e) => {
    const { name, value } = e.target;
    setDataAdm((prevState) => ({ ...prevState, [name]: value }));

    const isValidValue = validation[name].regex.test(value);
    setIsValid((prevState) => ({ ...prevState, [name]: isValidValue }));
  };
  ////Carga
  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner color="primary" />
        Cargando...
      </div>
    );
  }

  if (error) {
    return <Alert color="danger">{error}</Alert>;
  }

  return (
    <div>
      <Navbar expand="md" {...args}>
        <SidebarAdm />
        {/* <Container> */}
        {/* Logo a la izquierda */}
        <Nav>
          <Link to="/Administrador/Administrador" className="text-light">
            <img
              src={Logo}
              alt="logo"
              className="me-2"
              style={{
                height: 60,
                width: 120,
              }}
            />
          </Link>
        </Nav>
        {/* Toggler para dispositivos móviles */}
        <NavbarToggler onClick={toggle} />
        {/* Contenido colapsable */}
        <Collapse isOpen={isOpen} navbar>
          <Nav className="ms-auto" navbar>
            <NavbarText className="text-light">
              {/* Mostrar el temporizador de inactividad solo si el usuario está autenticado */}
              {isAuthenticated && (
                <div>Cierre de sesión en: {formatTime(remainingTime)}</div>
              )}
            </NavbarText>
            <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>
            {/* //REVISAR */}
            <NavbarText className="text-light">
              {dataAdm.nombre} {dataAdm.apellido}
            </NavbarText>
            {/* Dropdown a la derecha */}
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret className="text-light">
                MENU
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem onClick={() => toggleModal()}>
                  Instrucciones
                </DropdownItem>
                {lista.map((item) => (
                  <DropdownItem
                    key={item.id_com}
                    onClick={() => handleSelectItem(item)}
                  >
                    Postulacion
                  </DropdownItem>
                ))}
                <DropdownItem href="http://www.bqef.org/" target="_blank">
                  Sobre Nosotros...
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={() => abrirCerrarModalContra()}>
                  Cambiar Contraseña
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={() => handleBackup()} disabled={loading}>
                  {loading ? "Generando backup..." : "Generar backup"}
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={logoutSub}>Salir</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Collapse>
        {/* </Container> */}
      </Navbar>

      {/* MODAL CONTRASEÑA */}
      <Modal isOpen={modalContra}>
        <ModalHeader className="header_mo">Editar Contraseña</ModalHeader>
        <ModalBody>
          <Label>Clave Actual:</Label>
          <Input
            disabled
            type="text"
            className="form-control"
            value={dataAdm.contrasena_lit || "No disponible"}
          />
          <Label>Nueva Clave: </Label>
          <Input
            type="text"
            className="form-control"
            name="contrasena"
            onChange={handleChange}
          />
          {!isValid.contrasena && (
            <span style={{ color: "red" }}>
              La contraseña debe tener al menos 8 caracteres, incluyendo
              mayúsculas, minúsculas, números y caracteres especiales
            </span>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="success"
            size="lg"
            onClick={() => peticionPutContra()}
            disabled={!isValid.contrasena}
          >
            Guardar
          </Button>
          <Button
            color="danger"
            size="lg"
            onClick={() => abrirCerrarModalContra()}
          >
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal VER MANUAL ADMINISTRADOR*/}
      <Modal isOpen={modalVerManual} toggle={toggleModal} size="xl">
        <ModalHeader className="header_mo" close={cloBtnM}>
          Manual Usuario Administrador del Sistema
        </ModalHeader>
        <ModalBody>
          <Card>
            <CardBody className="p-0">
              <Row className="justify-content-center">
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "500px",
                  }}
                >
                  <object
                    data={require("../../Pages/Admin/documentos/manuales/MANUAL USUARIO ADMIN.pdf")}
                    type="application/pdf"
                    width="100%"
                    height="100%"
                  >
                    <p>
                      Este navegador no soporta PDFs. Por favor,
                      <a
                        href={require("../../Pages/Admin/documentos/manuales/MANUAL USUARIO ADMIN.pdf")}
                      >
                        {" "}
                        descarga el PDF
                      </a>{" "}
                      para verlo.
                    </p>
                  </object>
                </div>
              </Row>
            </CardBody>
          </Card>
        </ModalBody>
        <ModalFooter>
          <Button
            style={{ float: "right" }}
            color="success"
            size="lg"
            onClick={handleDownloadPdf}
          >
            <FaIcons.FaDownload />
            Download
          </Button>
          <Button color="danger" size="lg" onClick={() => toggleModal()}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal VER CONVOCATORIA */}
      <Modal isOpen={selectedItem !== null} toggle={closeBtn} size="xl">
        {selectedItem && (
          <>
            <ModalHeader className="header_mo" close={cloBtn}>
              {selectedItem.nom_doc}
            </ModalHeader>
            <ModalBody>
              <Card>
                <CardBody className="p-0">
                  <Row className="justify-content-center">
                    <object
                      data={
                        "data:application/pdf;base64," +
                        selectedItem.archivo_com
                      }
                      type="application/pdf"
                      alt="archivo_per"
                      width="400"
                      height="600"
                    >
                      <p>
                        Tu navegador no puede mostrar este archivo PDF. Puedes
                        descargarlo
                        <a
                          href={
                            "data:application/pdf;base64," +
                            selectedItem.archivo_com
                          }
                          download
                        >
                          aquí
                        </a>
                        .
                      </p>
                    </object>
                  </Row>
                </CardBody>
              </Card>
            </ModalBody>
            <ModalFooter>
              <Button
                style={{ float: "right" }}
                color="success"
                size="lg"
                onClick={handleDescargarPdf}
              >
                <FaIcons.FaDownload />
                Download
              </Button>
              <Button color="danger" size="lg" onClick={() => closeBtn()}>
                Cancelar
              </Button>
            </ModalFooter>
          </>
        )}
      </Modal>
      <Outlet />
    </div>
  );
}
export default NavbarAdm;
